export const apiBaseUrl = './moneytransfer/api/v1'
